import type { FC } from 'react'
import { Image03Icon } from '@/components/ui/icons'
import { ImagePreview } from '@/components/ui/image-preview'
import { Trans, useTranslation } from '@/translations/i18n'
import type { GalleryImage } from '../types'
import { getGalleryImageUrl } from '../utils'

interface ListingDetailsPhotoProps {
	photos: GalleryImage[]
	repositoryUrl?: string | null
}

export const ListingDetailsPhoto: FC<ListingDetailsPhotoProps> = ({
	photos,
	repositoryUrl
}) => {
	const { t } = useTranslation()
	return (
		<div className='grid h-full grid-cols-2 overflow-auto border-neutral-200 border-r bg-neutral-50'>
			{photos.length > 0 ? (
				photos.map((photo, index) => (
					<div className='p-6' key={`Listing ${index + 1}`}>
						<ImagePreview
							alt={`Listing ${index + 1}`}
							className='aspect-video h-full w-full rounded-xl border border-neutral-black/20 object-cover'
							height={'100%'}
							src={getGalleryImageUrl(photo, 'large') ?? ''}
							width={'100%'}
						/>
					</div>
				))
			) : (
				<div className='col-span-2 flex h-full w-full justify-center bg-neutral-50 text-neutral-400'>
					<div className='flex flex-col items-center py-8'>
						<div className='flex size-19 items-center justify-center rounded-full bg-neutral-100 text-neutral-500'>
							<Image03Icon />
						</div>
						{repositoryUrl ? (
							<>
								<span className='font-medium text-lg text-neutral-900'>
									{t(
										'luxe_submissions:photo_empty_title_repository_url'
									)}
								</span>

								<span className='text-center text-md text-neutral-700'>
									<Trans
										components={{
											a: (
												// biome-ignore lint/a11y/useAnchorContent: use inside Trans component
												<a
													className='cursor-pointer underline'
													href={repositoryUrl}
													rel='noopener noreferrer'
													target='_blank'
												/>
											)
										}}
										i18nKey='luxe_submissions:photo_empty_description_repository_url_submission_view'
									/>
								</span>
							</>
						) : (
							<>
								<span className='font-medium text-lg text-neutral-900'>
									{t('luxe_submissions:photo_empty_title')}
								</span>
								<span className='text-center text-md text-neutral-700'>
									{t(
										'luxe_submissions:photo_empty_description'
									)}
								</span>
							</>
						)}
					</div>
				</div>
			)}
		</div>
	)
}
